/** Maximum allowed file size for email attachments (2 MB in bytes). */
export const ATTACHMENT_SIZE_LIMIT = 2 * 1024 * 1024

/** MIME types accepted by the attachment upload input. */
export const ACCEPTED_ATTACHMENT_TYPES = ["image/png", "image/gif", "image/jpeg", "application/pdf"]
